var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Upload',{ref:"upload",attrs:{"headers":{
		'is-desensitization':'false'
	},"action":_vm.url||'/pc/chainSpecialityStores/importEmployeeInformation',"show-upload-list":_vm.showUploadList,"on-success":_vm.handleSuccess,"data":_vm.data,"before-upload":_vm.handleBeforeUpload,"on-remove":_vm.handleremove}},[_c('Button',{attrs:{"icon":"ios-cloud-upload-outline","loading":_vm.loading,"disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.btnText||'点击上传'))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d74214e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/haierProduct/components/common/UploadFileFlexible.vue
// module id = null
// module chunks = 